import { createStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/remote-users-store/useRemoteUsersStore.ts
var r = e((e, t) => ({
	currentRemoteUsers: [],
	getCurrentRemoteUsers: () => t().currentRemoteUsers,
	addCurrentRemoteUser: (n) => {
		if (t().currentRemoteUsers.find((e) => e.userId === n.userId)) {
			e({ currentRemoteUsers: t().currentRemoteUsers });
			return;
		}
		e({ currentRemoteUsers: [...t().currentRemoteUsers, n] });
	},
	updateRemoteUserPlayMode: (n, r) => {
		let i = t().currentRemoteUsers.find((e) => e.userId === n);
		i && (i.avatarPlayMode = r), e({ currentRemoteUsers: [...t().currentRemoteUsers] });
	},
	updateRemoteUserAgoraId: (n, r) => {
		let i = t().currentRemoteUsers.find((e) => e.userId === n);
		i && (i.agoraUserId = r), e({ currentRemoteUsers: [...t().currentRemoteUsers] });
	},
	removeCurrentRemoteUser: (n) => {
		e({ currentRemoteUsers: t().currentRemoteUsers.filter((e) => e.userId !== n) });
	},
	clearCurrentRemoteUsers: () => e({ currentRemoteUsers: [] })
})), i = (e) => t(r, n(e));
//#endregion
export { r as remoteUsersStore, i as useRemoteUsersStore };
